import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 4v2.286M4 12h2.286m11.428 0H20M6.364 6.397L7.98 8.014m9.655-1.617L16.02 8.014M9.552 19.25h4.894M8.57 11.81a3.429 3.429 0 115.143 2.97v1.351h-3.429v-1.352a3.427 3.427 0 01-1.714-2.97z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 1.5v3M1.5 12h3m15 0h3M4.604 4.646l2.122 2.122m12.672-2.121l-2.122 2.12M9 20.25h6m-7.5-8.5a4.5 4.5 0 116.75 3.898v2.102h-4.5v-2.102A4.498 4.498 0 017.5 11.75z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.999 3v6M3 24h6m30 0h6M9.206 9.293l4.242 4.243m25.344-4.243l-4.242 4.243M18 40.5h12m-15-17a9 9 0 1113.5 7.796V35.5h-9v-4.204A8.997 8.997 0 0115 23.5z"
  }))
};
export var Tip = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});